import { NgModule } from '@angular/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { InputDialogComponent } from './input-dialog.component';
import { TranslateModule } from '@ngx-translate/core';



@NgModule({
    declarations: [
      // InputDialogComponent
    ],
    imports     : [
       FuseSharedModule,
       TranslateModule
    ],
    exports: [
        // InputDialogComponent
    ]
})

export class InputDialogModule
{

}
